// The homepage FAQ content. Kept as data (not JSX) so both the rendered accordion and
// the FAQPage JSON-LD in the route read from one list.
export const HOME_FAQ_ITEMS = [
  {
    q: "Can a Lone Star tick bite make you allergic to red meat?",
    a: "Yes, in some people. Lone Star tick bites are linked to alpha-gal syndrome (AGS). It is a delayed allergy to meat from mammals, such as beef, pork, lamb and venison, and sometimes to dairy or gelatin. Most people who are bitten never get it. If you think you have it, talk to a doctor.",
  },
  {
    q: "Does every Lone Star tick bite cause alpha-gal syndrome?",
    a: "No. Most people bitten by a Lone Star tick never get alpha-gal syndrome. Some people get it after one bite, and some after many. A doctor can look at your symptoms and decide whether you need a test.",
  },
  {
    q: "What states have Lone Star ticks?",
    a: "They live across much of the South, the East and the lower Midwest, and they are spreading north. Your state's page says whether they live there, and what CDC records for each county.",
  },
  {
    q: "What should I do after a tick bite?",
    a: "Take the tick out with fine-tipped tweezers. Pull straight up, slowly and steadily. Wash the bite with soap and water or rubbing alcohol. Take a photo of the tick and write down the date and place. Then watch for symptoms for the next few weeks. Call a doctor if you get a rash, a fever or feel very tired, or if you react to food, mainly meat.",
  },
  {
    q: "How can I prevent Lone Star tick bites?",
    a: "Use a repellent registered with the EPA, such as DEET, picaridin or oil of lemon eucalyptus. Treat clothes and gear with permethrin. Stay out of tall grass and leaf litter, and tuck your pants into your socks in brushy places. When you come in, shower within two hours and check yourself, your kids and your pets for ticks.",
  },
  {
    q: "Can pets bring ticks into the home?",
    a: "Yes. Dogs and cats can carry ticks inside on their fur, and a tick can drop off onto a bed or carpet. Ask your vet about tick control you can use all year. Check pets after they have been outside, mainly around the ears and neck and between the toes.",
  },
  {
    q: "When is tick season?",
    a: "CDC says ticks are most active from April to September. In the South, Lone Star ticks can start in March and keep going into October, and in Florida they are active all year. Each state page gives its own months and says where they come from.",
  },
  {
    q: "How long does a Lone Star tick need to be attached to transmit anything?",
    a: "It depends on the germ, and for alpha-gal no one knows yet. So take any tick off as soon as you see it. The sooner it comes off, the lower the chance of an illness.",
  },
  {
    q: "What are early symptoms of alpha-gal syndrome?",
    a: "A reaction usually starts 2 to 6 hours after eating meat from a mammal, sometimes later. It can bring hives, itching, stomach pain, feeling sick, diarrhea or swelling. In bad cases it can cause anaphylaxis, a severe reaction that needs 911. Because it comes hours later, people often miss the link to meat. If you think you have it, see an allergist.",
  },
  {
    q: "How is alpha-gal syndrome diagnosed?",
    a: "A doctor or allergist can order a blood test for alpha-gal antibodies (called IgE). They look at the result together with your symptoms. LoneStarMap cannot diagnose or treat AGS, so please see a doctor.",
  },
  {
    q: "Is there a cure for alpha-gal syndrome?",
    a: "There is no cure yet. Most people manage it by not eating mammal meat and other products that set it off. For some people it gets better over several years if they avoid more tick bites. An allergist can help you make a plan.",
  },
  {
    q: "Can I get alpha-gal syndrome from other ticks?",
    a: "Most cases in the U.S. are linked to Lone Star tick bites. Scientists are still studying whether other ticks can cause it too. Protect yourself from all ticks.",
  },
  {
    q: "What does a Lone Star tick look like?",
    a: 'The adult female is reddish-brown with one white spot on her back, the "lone star". Males have small white marks around the edge instead. Young ticks, called nymphs, are about the size of a poppy seed. They cause many bites because they are so easy to miss.',
  },
  {
    q: "Should I send my tick for testing?",
    a: "Some labs and university extension programs will name a tick or test it for germs. Results can take a while, and they do not replace a visit to a doctor. To keep a tick, seal it in a bag with a damp paper towel.",
  },
  {
    q: "Are kids and pets at higher risk?",
    a: "They meet more ticks, because children play in grass and leaves and pets roam outside. Check them for ticks every day in tick season. Use a repellent that is safe for your child's age, and ask your vet about tick control.",
  },
  {
    q: "What's the difference between Lone Star ticks and deer ticks?",
    a: "Lone Star ticks are bigger and bite more readily. They are linked to alpha-gal syndrome and ehrlichiosis. Deer ticks are smaller and are the main tick that spreads Lyme disease. Both live in some of the same places.",
  },
  {
    q: "Is this site medical advice?",
    a: "No. LoneStarMap is a guide to help you learn. For medical advice, a diagnosis or treatment, see a doctor.",
  },
];
